module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3259zzUWVGqsgcuIquUW8y-9308ef6f420c6d0c2e85821ba79e7eff.jpg";